export enum AB_TESTS {
  EXAMPLE = 'abtest_example',
}

export const AB_TESTS_PREFIX = 'abtest';
